import { maxBy, reject } from 'lodash-es'

const SUPPORT_COMPRESSION_CHECK_TYPES = new Set<MemberCheckType>([
  'SupportCompression',
  'SteelSupportCompression',
])

export type ElementUtilization = {
  eta?: CombinedPositionCheck
  etaC?: CombinedPositionCheck
}

export const getElementUtilizationFromStructuralChecks = (
  elementGuid: string,
  structuralChecks: CombinedPositionCheck[] | null | undefined,
): ElementUtilization => {
  if (!structuralChecks?.length) return {}

  const checksForGuid = structuralChecks.filter(check => check.element_guid === elementGuid)
  if (!checksForGuid.length) return {}

  const supportChecks = checksForGuid.filter(check =>
    SUPPORT_COMPRESSION_CHECK_TYPES.has(check.check_type),
  )
  const nonSupportChecks = reject(checksForGuid, check =>
    SUPPORT_COMPRESSION_CHECK_TYPES.has(check.check_type),
  )

  const maxSupportCheck = maxBy(supportChecks, check => check.max_utilization)
  const maxNonSupportCheck = maxBy(nonSupportChecks, check => check.max_utilization)
  const maxAnyCheck = maxBy(checksForGuid, check => check.max_utilization)
  const etaSourceCheck = maxNonSupportCheck ?? maxAnyCheck

  const eta = etaSourceCheck
  const etaC = maxSupportCheck

  const result: ElementUtilization = {}
  if (eta !== undefined) result.eta = eta
  if (etaC !== undefined) result.etaC = etaC
  return result
}

export const hasUtilizationData = (utilization: ElementUtilization): boolean =>
  utilization.eta !== undefined || utilization.etaC !== undefined
